import React from "react"
import classnames from "classnames"
import {
  A,
  ArrowLeftIcon,
  Interactive
} from "AtomicComponents"
import gtmHandler from "AtomicUtils/gtmHandler"
import urlHandler from "AtomicUtils/urlHandler"

import styles from "./BackButton.less"
class BackButton extends React.PureComponent {

  _handleOnClick = () => {
    const {
      onClick = () => {},
      external,
      href,
      disabled,
      gtm,
      components,
      fallBackLink
    } = this.props
    onClick()

    // Delay for firing GTM before redirection
    // Call GTM if we have an gtm object
    if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
      gtmHandler({
        pageCategory: gtm.category,
        pageAction: gtm.action
      })
    }

    // legacy
    let newHref = href;
    let newExternal = external;
    if (fallBackLink && fallBackLink !="" ){
      newHref = fallBackLink
    }
    if (!href && components && components[0]){
      newExternal = components[0].props.external
      newHref = components[0].props.href
    }

    if (newExternal && newHref && !disabled) {
      setTimeout(() => {
        new urlHandler(newHref).newTab()
      }, 200)
    } else if (newHref && !disabled) {
      setTimeout(() => {
        new urlHandler(newHref).redirect()
      }, 200)
    }
  }

  render() {
    const {
      backText = 'Back',
      small = false
    } = this.props
    return (
      <div className={classnames({
        [styles.BackButton]: true,
        [styles.BackButtonSmall]: small
      })}>
        <A
          withoutStyle
          onClick={this._handleOnClick}
        >
          <ArrowLeftIcon style={{
            width: '15px',
            height: '15px',
            paddingBottom: '10px'
          }}/>
          <Interactive>{backText}</Interactive>
        </A>
      </div>
    )
  }
}


export default BackButton




// WEBPACK FOOTER //
// ./src/AtomicComponents/BackButton/BackButton.jsx